/// <amd-module name="typeahead/dataprovider/IClientSideCacheStatusChecker" />

export interface IClientSideCacheStatusChecker {
    isClientSideCacheDisabled(context: IContext): boolean;
}

export const isClientSideCacheDisabled: IPluginIdentifier = (plugin: object): boolean => {
    return (typeof plugin === "object")
        && (typeof (plugin as IClientSideCacheStatusChecker).isClientSideCacheDisabled === "function");
};
